import { fmtDuration, fmtPct, fmtNum1, nf } from "./format";

export const SCOPE_TITLE = {
  platform: ["Аналитика платформы", "Сводка по всей платформе: грузы, подбор машин, отклики и сделки."],
  shipper: ["Аналитика по грузам", "Как быстро ваши грузы находят машины и перевозчиков и сколько откликов вы получаете."],
  carrier: ["Аналитика перевозчика", "Подходящие грузы, отклики и сделки по вашим машинам, актуальность статусов."],
};

const T = {
  loads_published: "Грузы, созданные за период (кроме черновиков).",
  active_loads: "Неистекшие и незакрытые грузы на текущий момент (срок жизни и окно погрузки не закончились).",
  active_trucks_now: "Машины со статусом «Свободна», не истёкшие, на текущий момент (для грузоотправителя — подходящие под его активные грузы).",
  matches: "Подборы «груз — машина», прошедшие жёсткие фильтры, за период.",
  responses: "Подборы, по которым создан отклик или встречное предложение, за период.",
  counter_offers: "Подборы со встречным предложением по цене за период.",
  deals: "Рейсы (сделки), созданные за период.",
  supply_coverage_pct: "Активные грузы, для которых найдено не менее 3 подходящих свежих машин / активные грузы × 100.",
  first_match_seconds_avg: "Среднее время от публикации груза до первого подобранного транспорта (грузы без подбора не учитываются).",
  first_response_seconds_avg: "Среднее время от публикации груза до первого отклика перевозчика (грузы без откликов не учитываются).",
  match_to_response_pct: "Подборы за период, получившие хотя бы один отклик / все подборы за период × 100.",
  load_to_matched_pct: "Грузы за период, по которым выбран перевозчик (есть рейс) / опубликованные грузы × 100.",
  freshness_rate_pct: "Активные машины, статус которых подтверждён не более 2 часов назад / все активные машины × 100.",
  responses_per_load: "Отклики за период / опубликованные грузы за период.",
  repeat_dispatcher_pct: "Диспетчеры, опубликовавшие груз в периоде и имевшие более ранний груз / диспетчеры, опубликовавшие груз в периоде × 100.",
  driver_reactivation_pct: "Водители, обновлявшие «Ищу груз» в 2 и более разных дня периода / водители с любой такой активностью × 100.",
};

const c = (src, key, label, fmt, icon, tip) => ({ src, key, label, fmt, icon, tip: tip || T[key] });
const cnt = nf;

// cards per scope (ordered by what that audience cares about)
export const CARDS = {
  shipper: [
    c("totals", "loads_published", "Опубликовано грузов", cnt, "box"),
    c("totals", "active_loads", "Активные грузы", cnt, "arrow"),
    c("kpis", "first_match_seconds_avg", "До первой машины", fmtDuration, "truck"),
    c("kpis", "first_response_seconds_avg", "До первого отклика", fmtDuration, "chat"),
    c("kpis", "responses_per_load", "Откликов на груз", fmtNum1, "list"),
    c("totals", "responses", "Откликов всего", cnt, "chat"),
    c("totals", "deals", "Сделок", cnt, "check"),
    c("kpis", "load_to_matched_pct", "Груз → перевозчик", fmtPct, "target"),
    c("kpis", "match_to_response_pct", "Подбор → отклик", fmtPct, "target"),
    c("kpis", "supply_coverage_pct", "Покрытие предложением", fmtPct, "map"),
  ],
  carrier: [
    c("totals", "active_trucks_now", "Свободные машины сейчас", cnt, "truck"),
    c("totals", "matches", "Подходящих грузов", cnt, "box"),
    c("totals", "responses", "Откликов", cnt, "chat"),
    c("totals", "deals", "Сделок", cnt, "check"),
    c("kpis", "match_to_response_pct", "Подбор → отклик", fmtPct, "target"),
    c("kpis", "freshness_rate_pct", "Актуальность статусов", fmtPct, "check"),
    c("kpis", "driver_reactivation_pct", "Регулярное обновление «Ищу груз»", fmtPct, "user"),
    c("totals", "counter_offers", "Встречных предложений", cnt, "card"),
    c("totals", "active_loads", "Активных грузов на рынке", cnt, "arrow"),
    c("kpis", "first_response_seconds_avg", "Время до первого отклика", fmtDuration, "chat"),
  ],
  platform: [
    c("totals", "loads_published", "Опубликовано грузов", cnt, "box"),
    c("totals", "active_loads", "Активные грузы", cnt, "arrow"),
    c("totals", "active_trucks_now", "Свободные машины сейчас", cnt, "truck"),
    c("totals", "matches", "Подборов", cnt, "list"),
    c("totals", "responses", "Откликов", cnt, "chat"),
    c("totals", "deals", "Сделок", cnt, "check"),
    c("kpis", "supply_coverage_pct", "Supply coverage", fmtPct, "map"),
    c("kpis", "first_match_seconds_avg", "First match time", fmtDuration, "truck"),
    c("kpis", "first_response_seconds_avg", "First response time", fmtDuration, "chat"),
    c("kpis", "responses_per_load", "Откликов на груз", fmtNum1, "list"),
    c("kpis", "match_to_response_pct", "Match → response", fmtPct, "target"),
    c("kpis", "load_to_matched_pct", "Load → matched", fmtPct, "target"),
    c("kpis", "freshness_rate_pct", "Freshness rate", fmtPct, "check"),
    c("kpis", "repeat_dispatcher_pct", "Повторные диспетчеры", fmtPct, "user"),
    c("kpis", "driver_reactivation_pct", "Реактивация водителей", fmtPct, "user"),
  ],
};

export const FUNNEL = {
  shipper: [["matches", "Подходящие машины"], ["pushes_sent", "Уведомлено"], ["viewed", "Просмотрели"], ["responses", "Откликнулись"], ["deals", "Сделки"]],
  carrier: [["matches", "Подходящие грузы"], ["pushes_sent", "Уведомления"], ["viewed", "Просмотрено"], ["responses", "Ваши отклики"], ["deals", "Сделки"]],
  platform: [["matches", "Подборы"], ["pushes_sent", "Push отправлено"], ["viewed", "Просмотры"], ["responses", "Отклики"], ["deals", "Сделки"]],
};

export const LINES = {
  shipper: [["loads", "Грузы", "#005cff"], ["responses", "Отклики", "#00a85a"], ["deals", "Сделки", "#ff8800"]],
  carrier: [["matches", "Подборы", "#005cff"], ["responses", "Отклики", "#00a85a"], ["deals", "Сделки", "#ff8800"], ["active_trucks", "Свободные машины", "#8a5cf5"]],
  platform: [["loads", "Грузы", "#005cff"], ["matches", "Подборы", "#8a5cf5"], ["responses", "Отклики", "#00a85a"], ["deals", "Сделки", "#ff8800"]],
};
